import React from 'react'
import Header from '../header';
import Map from "../Map/map"
import {MasterGet} from "../mastervalue"
import { is_store } from '../..';
import Modal from '../modal'
import Toast from "../Toast/toast"


const ContactLayout = ({children}) => {
    return (
        <div className="contact-map">
            <Header />
            <Map />
            <div className="container-fluid contactinfo">
                <div className="row">
                    <div className="col-md-8">
                        {children}
                    </div>
                    <div className="col-md-4 contact-right">
                        <h3 className="f-600 m-b-20 m-t-20 p-t-20">Contact info</h3>
                        <div>
                            <p className="m-0">Mobile number</p>
                            <h4 className="m-b-20 m-t-0"><MasterGet id={is_store ? 9 : 7} /></h4>
                            <p className="m-0">Email address</p>
                            <h4 className="m-b-20 m-t-0">mail@ouja.in</h4>
                            <p className="m-0">Office address</p>
                            <h4 className="m-b-20 m-t-0">
                                Velachery, Chennai
                            </h4>
                            <div className="flex-start">
                                <a href="https://www.facebook.com/Ouja-557268384728637/" className="btn btn-round fb-color social-link">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                                <a href="https://twitter.com/OujaIndia" className="btn btn-round twitter-color social-link">
                                    <i className="fab fa-twitter"></i>
                                </a>
                                <a href="https://www.instagram.com/oujaindia/" className="btn btn-round insta-color social-link">
                                    <i className="fab fa-instagram"></i>

                                </a>
                                <a href="https://www.youtube.com/channel/UCaHd88KEbMxSUI6U1qYPdzw/" className="btn btn-round youtube-color social-link">
                                <i className="fab fa-youtube"></i>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal />
            <Toast />
        </div>
    )
}

export default ContactLayout
